import React from 'react';
import About from './About';
import Contact from './Contact';
import Terms from './Terms';
import Privacy from './Privacy';
import './SpecialPage.css';

function SpecialPage({ path }) {
  const pages = {
    '/about': About,
    '/contact': Contact,
    '/terms': Terms,
    '/privacy': Privacy,
  };

  const Page = pages[path] || About;

  return <Page />;
}

export default SpecialPage;